import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'oct-share-url',
    templateUrl: './share-url.component.html',
    styleUrls: ['./share-url.component.scss']
})
export class ShareUrlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
